import React from 'react';
import PerformanceHeatmap from '../simple/PerformanceHeatmap';
import DayOfWeek from '../simple/DayOfWeek';
import AdScheduleInsights from '../simple/AdScheduleInsights';
import ConversionActions from '../simple/ConversionActions';
import LandingPages from '../simple/LandingPages';
import GeoHotspots from '../simple/GeoHotspots';
import ConversionLag from '../simple/ConversionLag';
import TopKeywords from '../simple/TopKeywords';
import SearchTermMovers from '../simple/SearchTermMovers';

export default function InsightsPage({ refreshKey, dateRange }) {
  return (
    <div className="space-y-6">
      <PerformanceHeatmap key={`heatmap-${refreshKey}`} dateRange={dateRange} />
      <DayOfWeek key={`dow-${refreshKey}`} dateRange={dateRange} />
      <AdScheduleInsights key={`sched-${refreshKey}`} dateRange={dateRange} />
      <ConversionActions key={`cactions-${refreshKey}`} dateRange={dateRange} />
      <SearchTermMovers key={`movers-${refreshKey}`} dateRange={dateRange} />
      <LandingPages key={`lp-${refreshKey}`} dateRange={dateRange} />
      <GeoHotspots key={`geo-${refreshKey}`} dateRange={dateRange} />
      <ConversionLag key={`lag-${refreshKey}`} />
      <TopKeywords key={`kw-${refreshKey}`} showWasted dateRange={dateRange} />
    </div>
  );
}
